import createCookie from '../createCookie';
import storageAvailable from '../storageAvailable';

/**
 * Stores a value in storage. Defaults to looking in localStorage, but can be
 * changed via function params. Will fall back to using cookies if localStorage
 * or sessionStorage are not available.
 *
 * @param {Object} options The options for the function
 * @param {string} options.key The key to store the value under
 * @param {[type]} options.value The value to store
 * @param {Boolean} options.session Should the value be stored in sessionStorage?
 * @param {Boolean} options.forceCookies Should the value be stored in cookies?
 *
 * @public
 * @author Alex Kasemir
 */
const setStorage = ({ key, value, session = false, forceCookies = false }) => {
  const windowStorage = session ? `sessionStorage` : `localStorage`;
  const useCookies = forceCookies || !storageAvailable(windowStorage);

  if (typeof value !== `undefined` && value !== null) {
    let sValue = value;
    if (typeof value === `object`) {
      sValue = JSON.stringify(value);
    }

    if (useCookies) {
      createCookie(key, sValue, !session ? 365 : null);
    } else {
      window[windowStorage].setItem(key, sValue);
    }
  }
};

/** @component */
export default setStorage;
